// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Nrs8G","containerItemsCenter":"Skeleton_containerItemsCenter__10C8y"};